
export function targetScoreRangeRateAsRatio(value: number | null | undefined) {
  if (value === null || value === undefined) return null;
  return value / 100;
}
